import { ChevronRight } from '@mui/icons-material';
import {
  Box,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup,
} from '@mui/material';
import { Field } from 'formik';
import PropTypes from 'prop-types';

export default function YesNoRadioGroupField({
  name,
  label,
  helperText,
  disabled,
  error,
  locale,
  horizontalLayoutEnabled,
  isLoading,
}) {
  return (
    <Field name={name}>
      {({ field, form }) => (
        <FormControl
          disabled={disabled}
          error={error}
          sx={{
            ...(horizontalLayoutEnabled && {
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
            }),
          }}
        >
          <Box sx={{ display: 'flex' }}>
            {horizontalLayoutEnabled && (
              <Box
                sx={{
                  width: '24px',
                  height: '24px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {isLoading ? (
                  <CircularProgress size={16} />
                ) : (
                  <ChevronRight color={disabled ? 'disabled' : 'inherit'} sx={{ fontSize: 24 }} />
                )}
              </Box>
            )}

            <FormLabel id={field.name} component="legend">
              {label}
            </FormLabel>
          </Box>

          <RadioGroup
            aria-labelledby={field.name}
            name={field.name}
            value={field.value ?? ''}
            disabled={disabled}
            onChange={async (event) => {
              await field.onChange(event);
              form.handleSubmit();
            }}
            row
            sx={{ flexWrap: 'nowrap' }}
          >
            <FormControlLabel value={'yes'} control={<Radio />} label={locale === 'es' ? 'Si' : 'Yes'} />
            <FormControlLabel value={'no'} control={<Radio />} label={'No'} />
          </RadioGroup>

          {helperText && <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>
      )}
    </Field>
  );
}

YesNoRadioGroupField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  helperText: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  isLoading: PropTypes.bool,
  locale: PropTypes.oneOf(['en', 'es']).isRequired,
  horizontalLayoutEnabled: PropTypes.bool,
};
